/** Gets a normalized one-line version of the comment text for compact previews and labels. */
export function getCommentSnippet(body: string): string {
  return body.replace(/\s+/g, ' ').trim()
}
